import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import gsap from "gsap";

const cursorAnim = (cursor) => {
  gsap.to(cursor.current, { xPercent: -50, yPercent: -50 });

  window.addEventListener("mousemove", (e) => {
    const { clientX, clientY } = e;
    gsap.to(cursor.current, { x: clientX, y: clientY });
  });
};

export const CurText = (text) => {
  const CurText = useRef(null);
  useEffect(() => {
    cursorAnim(CurText);
  }, []);
  return (
    <>
      <div className="curText" ref={CurText}></div>
    </>
  );
};

const Cursor = () => {
  const cursor = useRef();

  useEffect(() => {
    cursorAnim(cursor);
  }, []);

  return (
    <CursorStyle>
      <div className="cursor" ref={cursor}></div>
    </CursorStyle>
  );
};

export default Cursor;

const CursorStyle = styled.div``;
